<template>
  <button @click="onExpand" :class="['activate-table-icon-component border-0 bg-transparent', stylingClasses]">
    <font-awesome-icon v-if="expanded" icon="fa-solid fa-angle-up" />
    <font-awesome-icon v-else icon="fa-solid fa-angle-down" />
  </button>
</template>

<script src="./table-column-icon.js"></script>
